import * as angular from 'angular'
import './title.scss';
import { Component, Input } from 'ng-metadata/core';

/**
 * @name mwMediaContactDocumentTitle
 * @module mw.components.contentDocuments
 *
 * @param {string} [text] - text to be displayed inside component.
 *
 * @description
 * `<mw-media-contact-document-title>` is a component used to display the job title.
 *
 * @usage
 * <hljs hljs-language="html">
 *     <mw-media-contact-document-title
 *          text="::$ctrl.contact.jobTitle">
 *     </mw-media-contact-document-title>
 * </hljs>
 */
@Component({
    selector: 'mw-media-contact-document-title',
    template: `
        <span
            class="mw-media-contact-document-title"
            ng-bind-html="::$ctrl.text">
        </span>
    `,
})
export class MediaContactDocumentTitleComponent {
    @Input('<') text: string;
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-contact-document/title/title.component.ts